export const LABELS = {
  CONFIRM_ADDRESS: 'Confirm Address',
  SELECT_PROPERTY: 'Start a New Property Account',
  ALREADY_ON_QM:
    'Think your household member might already be on Quartermaster?',
  JOIN_HOUSEHOLD: 'Join my Household',
  VERIFY: 'Verify',
};
